import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ProfessionalComponent } from './professional.component';
import { ProfessionalHomeComponent } from './components/home/professional-home.component';

import { ProfessionalAttachedComponent } from './components/attached/professional-attached.component';
import { ProfessionalRankingComponent } from './components/ranking/list/professional-ranking.component';
import { ProfessionalRankingClassifComponent } from './components/ranking/classification/professional-ranking-classif.component';
import { ProfessionalRankingHistoryComponent } from './components/ranking/history/professional-ranking-history.component';
import { SharedAttachmentsDetailComponent } from '@theme/components';

const routes: Routes = [
    {
        path: '',
        component: ProfessionalComponent,
        children: [
            { path: 'home', component: ProfessionalHomeComponent },
            {
                path: 'tournament',
                loadChildren: () => import('../tournament/tournament.module').then((m) => m.TournamentModule),
            },
            { path: 'ranking-2', loadChildren: () => import('../ranking/ranking.module').then((m) => m.RankingModule) },
            { path: 'ranking', component: ProfessionalRankingComponent },
            {
                path: 'ranking-classif/:rankingId',
                component: ProfessionalRankingClassifComponent,
            },
            {
                path: 'history',
                component: ProfessionalRankingHistoryComponent,
            },
            {
                path: 'attached/:sessionType',
                component: ProfessionalAttachedComponent,
            },
            { path: 'attached/:sessionType/detail/:docId', component: SharedAttachmentsDetailComponent },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ProfessionalRoutingModule {}
